import { EditableText as EditableTextComponent } from "@smart/itops-sb-design-system-dom";

import { useEditing } from "./context";

export const EditableText = (
  props: React.ComponentProps<typeof EditableTextComponent> & {
    onSave?: (value: string) => void;
  },
) => {
  const { registerEditor, unregisterEditor, setSelectedText } = useEditing();
  return (
    <EditableTextComponent
      {...props}
      useExternalToolbar
      showEditLink={false}
      onEditorActive={(editor) =>
        registerEditor(editor, (content) => {
          props.onChange?.(content);
          props.onSave?.(content);
        })
      }
      onEditorInactive={unregisterEditor}
      onTextSelected={setSelectedText}
    />
  );
};
